import * as React from 'react';

import DemoBlockedModal from './demoBlockedModal';

import { useDemoAccountContextProvider } from '../../contexts/DemoAccountContextProvider';

interface DemoGuardedButtonProps {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  disabled?: boolean;
  ariaLabel?: string;
}

const DemoGuardedButton: React.FC<DemoGuardedButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  ariaLabel,
}) => {
  const { isDemo } = useDemoAccountContextProvider();
  const [showModal, setShowModal] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isDemo) {
      setShowModal(true);
    } else {
      onClick(event);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <React.Fragment>
      <button
        aria-label={ariaLabel}
        className={className}
        disabled={disabled}
        onClick={handleClick}
        type="button"
      >
        {children}
      </button>
      {showModal && <DemoBlockedModal onClose={handleCloseModal} />}
    </React.Fragment>
  );
};

export default DemoGuardedButton;
